
import { motion } from 'framer-motion';
import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import ProjectsList from '@/components/projects/ProjectsList';

const ProjectsPage = () => {
  return (
    <>
      <SeoHead
        route="/projects"
        lang="pt-BR"
        title="Produtos & Projetos — Johnny Vaz"
        description="Consultoria de IA, SaaS próprios, plataformas white-label e parcerias de desenvolvimento. Conheça o portfólio de produtos e serviços do Johnny Vaz."
      />
      <Navbar />

      {/* Hero da página */}
      <section
        style={{ backgroundColor: '#0B0B0B', paddingTop: '7rem', paddingBottom: '4rem' }}
      >
        <div className="container mx-auto px-6 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p
              style={{
                fontFamily: "'JetBrains Mono', ui-monospace, monospace",
                fontSize: '0.7rem',
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#FF4500',
                marginBottom: '1.25rem',
              }}
            >
              Portfólio · Johnny Vaz
            </p>
            <h1
              style={{
                fontFamily: "'Anton', 'Archivo Black', sans-serif",
                fontSize: 'clamp(3rem, 9vw, 6.5rem)',
                lineHeight: 0.88,
                letterSpacing: '-0.01em',
                textTransform: 'uppercase',
                color: '#F2EDE3',
                marginBottom: '2rem',
              }}
            >
              PRODUTOS<br />
              <span style={{ color: '#FF4500' }}>&</span><br />
              PROJETOS
            </h1>
            <div
              style={{
                height: '2px',
                backgroundColor: '#FF4500',
                width: '64px',
                marginBottom: '2rem',
              }}
            />
            <p
              style={{
                fontFamily: "'Space Grotesk', system-ui, sans-serif",
                fontSize: 'clamp(1rem, 2.2vw, 1.2rem)',
                lineHeight: 1.65,
                color: '#8C8377',
                maxWidth: '540px',
              }}
            >
              Consultoria estratégica de IA, SaaS com skin in the game,
              plataformas white-label e parcerias de desenvolvimento 50/50.
              Tudo construído para gerar resultado mensurável.
            </p>
          </motion.div>
        </div>
      </section>

      <main>
        <ProjectsList />
      </main>

      <Footer />
    </>
  );
};

export default ProjectsPage;
